import { Inject, Injectable } from '@angular/core';

// Ionic Modules
import { LocalNotifications } from '@capacitor/local-notifications';
import { Platform } from '@ionic/angular';
import OneSignal from 'onesignal-cordova-plugin';
import { OpenedEvent } from 'onesignal-cordova-plugin/dist/models/NotificationOpened';
import NotificationReceivedEvent from 'onesignal-cordova-plugin/dist/NotificationReceivedEvent';

// Abstracts
import { NgInternalLinkService, NgNotificationService, NOTIFICATION_APP_ID } from '../abstracts';

@Injectable()
export class NotificationService implements NgNotificationService {

  constructor(
    @Inject(NOTIFICATION_APP_ID)
    private appId: string,
    private platform: Platform,
    private internalLinkService: NgInternalLinkService) { }

  public init(enable: boolean) {
    if (this.platform.is('capacitor')) {
      OneSignal.setLogLevel(6, 0);
      OneSignal.setAppId(this.appId);
      OneSignal.setNotificationOpenedHandler((openedEvent: OpenedEvent) => this.notificationOpened(openedEvent));
      OneSignal.setNotificationWillShowInForegroundHandler((event: NotificationReceivedEvent) => {
        const notification = event.getNotification();

        LocalNotifications.addListener('localNotificationActionPerformed', (notificationAction) => {
          if (notificationAction.actionId === 'tap' ) {
            const additionalData = notificationAction.notification.extra;
            if (additionalData) {
              const launchURL = additionalData['launchURL'];
              if (launchURL) {
                this.internalLinkService.check(launchURL);
              } else {
                const content_id = additionalData['content_id'];
                if (content_id) {
                  this.internalLinkService.checkId(content_id);
                }
              }
            }
          }
        });

        LocalNotifications.schedule({
          notifications: [
            {
              id: 0,
              title: notification.title,
              body: notification.body,
              extra: notification.additionalData,
            }
          ]
        });
      });

      if (enable) {
        OneSignal.promptForPushNotificationsWithUserResponse(true);
      }
    }
  }

  private notificationOpened(openedEvent: OpenedEvent) {
    const launchURL = openedEvent.notification.launchURL;
    const additionalData = openedEvent.notification.additionalData;

    if (launchURL) {
      this.internalLinkService.check(launchURL);
    }
    else if (additionalData) {
      const content_id = additionalData['content_id'];
      if (content_id) {
        this.internalLinkService.checkId(content_id);
      }
    }
  }

}
